export function passwordError(password: string, confirmation: string): string {
  if (password.length < 8 || password.length > 72 || !/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/[0-9]/.test(password) || !/[^A-Za-z0-9]/.test(password)) {
    return "Use 8–72 characters with an uppercase letter, a lowercase letter, a number, and a special character.";
  }
  return password === confirmation ? "" : "Passwords do not match.";
}
